import styled from "styled-components";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  .hero-body {
    .subtitle {
      margin-bottom: 0 !important;
    }
  }
  .publish {
    color: #495057;
  }
  .searchBox {
    .searchInput {
      width: 100%;

      .input {
        &:focus {
          box-shadow: none !important;
        }
      }
    }
    .search {
      background-color: #595959;
    }
    .filter {
      margin-left: 1rem;
      width: 12rem;
    }
    .toggleGrid {
      margin-left: 1rem;
    }
    .selectCategory {
      width: 30rem;
      margin: 0 0 1rem 1rem;
    }
  }
  .selectCategory {
    width: auto;
    margin-bottom: 1.5rem;
  }
  .filterSection {
    display: flex;
    flex-direction: column;

    .filter {
      margin-bottom: 0.8rem;
      padding: 15px;
    }
    .checkboxInput {
      margin-right: 5px;
    }
    .text {
      margin-top: -2px;
    }
    .compensation {
      display: flex;
      flex-direction: row;
      align-items: center;

      .label {
        margin-right: 1rem;
      }
      .input {
        width: 10rem;
        margin-right: 0.5rem;
      }
    }
  }
  .separator {
    margin-top: 1rem;
  }
  .warning {
    text-align: center;
  }
  .loadMore {
    margin-top: 20px;
    text-align: center;
  }
  .hero.welcome.is-info {
    background: #36d1dc;
    background: linear-gradient(to right, #5b86e5, #36d1dc);
    border-radius: 6px;
    margin-bottom: 20px;
    .container {
      margin: 0;
    }
  }
  .mobileApps {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 2rem;
    img {
      cursor: pointer;
    }
    .title {
      margin: 0 10px 0 0;
    }
  }
`;
